import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CNPJValidation } from '@shared/constants/cnpj-validator.constants';
import { CPFValidation } from '@shared/constants/cpf-validator.constants';

export class CustomValidators {
  /**
   * @description
   * Valida CNPJ numérico ou alfanumérico (RFB jul/2026) pelo dígito verificador.
   * Campo vazio é considerado válido (use Validators.required separadamente).
   */
  static cnpj(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;
    return CNPJValidation(value) ? null : { invalidCnpj: true };
  }

  /**
   * @description
   * Valida CPF pelo dígito verificador. Campo vazio é considerado válido
   * (use Validators.required separadamente).
   */
  static cpf(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;
    return CPFValidation(value) ? null : { invalidCpf: true };
  }

  static requireAtLeastOneTrue(controls: string[]): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const atLeastOneChecked = controls.some((controlName) => {
        const control = group.get(controlName);
        return control && control.value === true;
      });

      return atLeastOneChecked ? null : { requireAtLeastOneTrue: true };
    };
  }

  static minWords(min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      const words = String(control.value).trim().split(/\s+/).filter((w) => w.length > 0);
      return words.length >= min ? null : { minWords: { required: min, actual: words.length } };
    };
  }

  /**
   * @description
   * Validator that requires the control's value to be a valid email address.
   * This validation is based on a stricter regex than the default `Validators.email`.
   */
  static email(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }
    const regex =
      /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/i;
    const valid = regex.test(control.value);
    return valid ? null : { email: true };
  }

  static filled(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? { required: true } : null;
    }
    if (Array.isArray(value)) {
      return value.length > 0 ? null : { required: true };
    }

    const raw = value !== null && typeof value === 'object' && 'value' in value ? value.value : value;
    const isEmpty = raw === null || raw === undefined || String(raw).trim() === '';
    return isEmpty ? { required: true } : null;
  }

  static mobilePhone(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    const digits = String(control.value).replace(/\D/g, '');
    return /^[1-9]{2}9\d{8}$/.test(digits) ? null : { mobilePhone: true };
  }
}
